import { createSlice } from "@reduxjs/toolkit";

export const sharedSlice = createSlice({
  name: "shared",
  initialState: {
    savingsCategories: [],
    customStocks: [],
  },
  reducers: {
    setSavingsCategories: (state, action) => {
      state.savingsCategories = action.payload;
    },
    setCustomStocks: (state, action) => {
      state.customStocks = action.payload;
    },
  },
});

export const { setSavingsCategories, setCustomStocks } = sharedSlice.actions;

export default sharedSlice.reducer;
